import React from 'react';
import { Link } from 'react-router-dom';
import CancellationPolicyNotice from '../components/common/CancellationPolicyNotice';
import { ArrowLeftIcon } from '@heroicons/react/outline';

const CancellationPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-4"
          >
            <ArrowLeftIcon className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Cancellation & Refund Policy</h1>
          <p className="text-gray-600 mt-2">Last updated: January 2025</p>
        </div>

        {/* Full Policy */}
        <CancellationPolicyNotice variant="full" showFullPolicy={true} />

        {/* Contact Section */}
        <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-blue-900 mb-3">Need Help?</h3>
          <p className="text-blue-800 mb-4">
            If you have questions about our cancellation policy or need assistance with a cancellation, 
            our support team is here to help.
          </p>
          <div className="space-y-2">
            <p className="text-blue-800">
              <strong>Email:</strong>{' '}
              <a href="mailto:contact@guardly.app" className="text-blue-600 hover:underline">
                contact@guardly.app
              </a>
            </p>
            <p className="text-blue-800">
              <strong>Response Time:</strong> Within 24 hours
            </p>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Related Policies</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Link 
              to="/terms" 
              className="block p-4 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-sm transition-all"
            >
              <h4 className="font-medium text-gray-900 mb-1">Terms of Service</h4>
              <p className="text-sm text-gray-600">Our complete terms and conditions</p>
            </Link>
            <Link 
              to="/privacy" 
              className="block p-4 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-sm transition-all"
            >
              <h4 className="font-medium text-gray-900 mb-1">Privacy Policy</h4>
              <p className="text-sm text-gray-600">How we handle your data</p>
            </Link>
            <Link 
              to="/faq" 
              className="block p-4 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-sm transition-all"
            >
              <h4 className="font-medium text-gray-900 mb-1">FAQs</h4>
              <p className="text-sm text-gray-600">Common questions answered</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;